import { defineComponent } from "vue";
import useRoomInvite from "./useRoomInviteHooks.mjs";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import TuiButton from "../common/base/Button.vue.mjs";
import Contacts from "../ScheduleConference/Contacts.vue.mjs";
import SuccessIcon from "../common/icons/SuccessIcon.vue.mjs";
import copyIcon from "../common/icons/CopyIcon.vue.mjs";
import Dialog from "../common/base/Dialog/index.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "indexPC",
  setup(__props) {
    const {
      t,
      invitationFeatureDetails,
      showContacts,
      contactsConfirm,
      contacts,
      remoteEnteredUserList,
      isShowRoomShareForm,
      userId,
      userName,
      inviteInfoList,
      onCopy,
      copyRoomIdAndRoomLink
    } = useRoomInvite();
    return { __sfc: true, t, invitationFeatureDetails, showContacts, contactsConfirm, contacts, remoteEnteredUserList, isShowRoomShareForm, userId, userName, inviteInfoList, onCopy, copyRoomIdAndRoomLink, SvgIcon, TuiButton, Contacts, SuccessIcon, copyIcon, Dialog };
  }
});
export {
  _sfc_main as default
};
